import React, { useState } from 'react';
import { Submission } from '../lib/types';
import { PhotoCard } from './PhotoCard';
import { Trophy, Share2 } from 'lucide-react';
import { ConfettiCelebration } from "./ConfettiCelebration";

interface WinnerCardProps {
  winner: Submission | undefined;
  isVoted: boolean;
  onVote: (submissionId: string) => void;
}

export function WinnerCard({ winner, isVoted, onVote }: WinnerCardProps) {
  const [confetti, setConfetti] = useState(false);

  React.useEffect(() => {
    if (winner && isVoted) {
      setConfetti(true);
      const t = setTimeout(() => setConfetti(false), 2000);
      return () => clearTimeout(t);
    }
  }, [winner?.id, isVoted]);

  const handleShare = () => {
    if (winner) {
      const shareData = {
        title: 'Foto Fight Winner!',
        text: `Check out today's winner: ${winner.username} 🎉`,
        url: winner.photoUrl
      };
      if (navigator.share) {
        navigator.share(shareData);
      } else {
        navigator.clipboard.writeText(winner.photoUrl);
        alert('Winner photo URL copied!');
      }
    }
  };

  if (!winner) return null;

  return (
    <div className="relative">
      <ConfettiCelebration trigger={confetti} />
      <div className="flex items-center mb-4">
        <Trophy className="h-5 w-5 text-bauhaus-green mr-2" />
        <h3 className="text-lg font-medium text-bauhaus-green">Winner</h3>
        <button
          className="ml-auto flex items-center text-bauhaus-green hover:underline text-sm"
          title="Share this winner"
          onClick={handleShare}
          type="button"
        >
          <Share2 className="w-4 h-4 mr-1" /> Share
        </button>
      </div>
      <PhotoCard
        submission={winner}
        isVoted={isVoted}
        isWinner={true}
        onVote={onVote}
        showComments={true}
      />
    </div>
  );
}
